enum ErrorType {
    badRequest = 'badRequest',
    authenticationNeeded = 'authenticationNeeded',
    forbidden = 'forbidden',
    resourceNotFound = 'resourceNotFound',
    serverError = 'serverError',
    timeout = 'timeout',
    networkError = 'networkError',
    socketConnectionError = 'socketConnectionError',
    socketDisconnectError = 'socketDisconnectError',
    generic = 'generic'
}

export default ErrorType;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/errors/network/ErrorType.ts